import { api } from '@/lib/api'
import type { ClientIntakeForm, ClientIntakeRecord, ClientIntakeSaveResponse } from './types'

export const clientIntakeApi = {
  get: () => api.get<ClientIntakeRecord | null>('/api/form'),
  save: (data: ClientIntakeForm) =>
    api.post<ClientIntakeSaveResponse>('/api/form', data),
}
